import { useEffect, useState } from "react";
import "./HExpEditor.css";
import { useDataProvider, useNotify, useDelete } from "react-admin";
import { Gallery } from "../Gallery/Gallery";

export const HExpEditor = (props: any) => {
  const {
    createNewLabel,
    resource,
    updatedOrderMsg,
    updatingOrderMsg,
    CreateScreen,
    EditScreen,
    hasOrder,
    hasEnabled,
    heading,
    propertyId,
    limit,
  } = props;

  const [tab, setTab] = useState<"list" | "edit" | "create">("list");
  const [editedId, setEditedId] = useState<string>("");
  const [deletedId, setDeletedId] = useState<string | null>(null);

  const [open, setOpen] = useState(false);

  const [, { isLoading }] = useDelete();

  const handleDeleteClick = (id: string) => {
    setDeletedId(id);
    setOpen(true);
  };
  const handleDialogClose = () => setOpen(false);

  const handleConfirm = async () => {
    const ids = resources
      .filter((r: any) => r.id !== deletedId)
      .map((r: any) => r.id);

    const { data } = await dataProvider.updatePropertyHighlightedExperiences(
      propertyId,
      {
        highlightedExperiences: ids,
      },
    );

    fetchResources();
    setOpen(false);
    setDeletedId(null);
  };

  const dataProvider = useDataProvider();
  const notify = useNotify();

  const [resources, setResources] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchResources = async () => {
    try {
      setLoading(true);

      const { data } = await dataProvider.getPropertyHExps({
        propertyId: propertyId,
      });

      setResources(data);
    } catch (err: any) {
      notify(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResources();
  }, []);

  const moveMainItem = async (index: number, direction: "up" | "down") => {
    const movedResources = [...resources];

    if (direction === "up" && index > 0 && index < movedResources.length) {
      const removedItem = movedResources.splice(index, 1)[0];
      movedResources.splice(index - 1, 0, removedItem);
    }

    if (
      direction === "down" &&
      index >= 0 &&
      index < movedResources.length - 1
    ) {
      const removedItem = movedResources.splice(index, 1)[0];
      movedResources.splice(index + 1, 0, removedItem);
    }

    setResources(movedResources);

    await updateResourcesOrder(movedResources);
  };

  const removeItem = async (index: number, id: string) => {
    handleDeleteClick(id);
  };

  const updateResourcesOrder = async (movedResources: any[]) => {
    notify(updatingOrderMsg);

    const ids = movedResources.map((r: any) => r.id);

    const { data } = await dataProvider.updatePropertyHighlightedExperiences(
      propertyId,
      {
        highlightedExperiences: ids,
      },
    );

    notify(updatedOrderMsg);
  };

  const onCreated = async (id: any) => {
    if (!id.id) {
      const ids = resources.map((r: any) => r.id);

      const { data } = await dataProvider.updatePropertyHighlightedExperiences(
        propertyId,
        {
          highlightedExperiences: [...ids, id],
        },
      );
    }

    fetchResources();
    changeTab("list");
  };

  const changeTab = (newTab: "list" | "edit" | "create", id?: string) => {
    if (id) {
      setEditedId(id);
    }

    setTab(newTab);
  };

  return (
    <div className="wrapper">
      <Gallery
        hasOrder={hasOrder}
        tab={tab}
        moveMainItem={moveMainItem}
        heading={heading}
        loading={loading}
        limit={limit}
        resources={resources}
        changeTab={changeTab}
        createNewLabel={createNewLabel}
        removeItem={removeItem}
        isOpen={open}
        isLoading={isLoading}
        handleConfirm={handleConfirm}
        handleDialogClose={handleDialogClose}
        createScreen={
          <CreateScreen
            onCreated={onCreated}
            hasEnabled={hasEnabled}
            resource={resource}
            propertyId={propertyId}
          />
        }
        editScreen={
          <EditScreen
            id={editedId}
            resource={resource}
            onCreated={onCreated}
            hasEnabled={hasEnabled}
            propertyId={propertyId}
          />
        }
      />
    </div>
  );
};
